import {
  TimesheetFlowFooter,
  TimesheetFlowFooterButton,
} from "@/features/timesheetFlow/components/TimesheetFlowFooter";
import type { TimesheetProjectPreset } from "@/features/timesheetFlow/timesheetFlowTypes";

export function MischmaschChoiceScreen({
  project,
  onTimesheet,
  onBack,
}: {
  project: TimesheetProjectPreset;
  onTimesheet: () => void;
  onBack: () => void;
}) {
  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-label-secondary">
        Zu diesem Auftrag gibt es auch Festpreispositionen, die mit auf den Nachweis geschrieben werden
        sollen.
      </p>
      <p className="text-xs text-label-tertiary">
        Auftrag: {project.auftragsnummer}
        {project.kunde ? ` · ${project.kunde}` : ""}
      </p>
      <TimesheetFlowFooter>
        <TimesheetFlowFooterButton type="button" variant="secondary" onClick={onBack}>
          Zurück
        </TimesheetFlowFooterButton>
        <TimesheetFlowFooterButton type="button" onClick={onTimesheet}>
          Stundennachweis
        </TimesheetFlowFooterButton>
      </TimesheetFlowFooter>
    </div>
  );
}
